<template>
  <div class="text-center">
    <div v-if="pageUrl" class="my-4">
      <a
        target="_blank"
        rel="noopener noreferrer"
        :href="
          `https://developers.google.com/speed/pagespeed/insights/?url=${encodeURIComponent(
            pageUrl,
          )}`
        "
      >
        {{ $t("editPage.link:seeFullReport") }}
      </a>
    </div>
    <div class="my-4">
      <a
        href="https://developers.google.com/speed/docs/insights/about/"
        target="_blank"
        rel="noopener noreferrer"
        >{{ $t("editPage.link:aboutPagespeedInsights") }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageUrl: { type: String, required: true },
  },
  name: "ReportFooter",
};
</script>

<style></style>
